import { render, staticRenderFns } from "./StudentSignUp.vue?vue&type=template&id=7713ccf4&scoped=true&"
import script from "./StudentSignUp.vue?vue&type=script&lang=js&"
export * from "./StudentSignUp.vue?vue&type=script&lang=js&"
import style0 from "./StudentSignUp.vue?vue&type=style&index=0&id=7713ccf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7713ccf4",
  null
  
)

export default component.exports